import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { auth, signInWithEmailAndPassword } from '../firebase.js';
import { FormField } from '../components/FormField.jsx';

export default function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      nav('/profile');
    } catch (e) {
      setErr(prettifyAuthError(e.code));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-[70vh] flex items-center">
      <div className="max-w-sm w-full mx-auto px-4">
        <div className="eyebrow text-brand mb-3">Members</div>
        <h1 className="font-display text-4xl mb-8">Sign in.</h1>
        <form onSubmit={submit} className="space-y-4">
          <FormField label="Email">
            <input
              type="email"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </FormField>
          <FormField label="Password">
            <input
              type="password"
              className="input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </FormField>
          {err && <p className="text-sm text-danger">{err}</p>}
          <button type="submit" className="btn-primary w-full h-11" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        <p className="text-sm text-ink-2 mt-8">
          Not a member yet?{' '}
          <Link to="/signup" className="text-brand underline underline-offset-4 font-medium">
            Create an account
          </Link>
        </p>
      </div>
    </div>
  );
}

function prettifyAuthError(code) {
  if (!code) return 'Something went wrong.';
  const map = {
    'auth/invalid-credential': 'Email or password is incorrect.',
    'auth/user-not-found': 'No account with that email.',
    'auth/wrong-password': 'Incorrect password.',
    'auth/too-many-requests': 'Too many attempts. Try again in a minute.',
  };
  return map[code] || 'Sign-in failed.';
}
